export const validateIndonesianNPWPAgainstGovID = (npwp: string, govId: string) => {
  const cleanNPWP = npwp.replace(/\D/g, ''); 
  if (cleanNPWP.length < 16) {
    return null;
  }
  const isValidNPWP = /^\d{16}$/.test(cleanNPWP);
  return isValidNPWP && cleanNPWP === govId ? null : 'taxIdMismatchWithGovId';
}
